export const currentWindowSize = () => {
  let size = 'xsmall';
  if (window.matchMedia('(min-width: 768px)').matches) {
    size = 'small';
  }
  if (window.matchMedia('(min-width: 992px)').matches) {
    size = 'medium';
  }
  if (window.matchMedia('(min-width: 1200px)').matches) {
    size = 'large';
  }
  return size;
};

export const matchMedia = (mediaSize) => {
  let minWidth = '';
  switch (mediaSize) {
    case 'small':
      minWidth = '(min-width: 768px)';
      break;
    case 'medium':
      minWidth = '(min-width: 992px)';
      break;
    case 'large':
      minWidth = '(min-width: 1200px)';
      break;
    default:
      break;
  }
  return window.matchMedia(minWidth).matches;
};

export const userAgent = device => (navigator.userAgent.indexOf(device) > -1);
